import problemCategoryConfig from "../config/ProblemCategoryConfig";
import {FeatureManager} from "@amzn/dolphin-web-framework";

export const fetchProblemCategoryConfig = () => {
  if(FeatureManager.isFeatureEnabled(FeatureManager.Features.WRONG_PLANNED_STATION_RTO_DISABLED))
  {
    problemCategoryConfig["WRONG_PLANNED_STATION"].actionList = ["WRONG_PLANNED_STATION_TRANSFER"];
  }
  return problemCategoryConfig;
};